import React from 'react';
import { formatMeasurement } from 'shared/helpers';
import { DASHBOARD_VOLUME_TYPE_LABEL } from './constants';
import { getClusterVolumeAndWeightByType } from './helpers';
import {
  type ClusterDetailItem,
  type ClusterVolumeMeasurementsProps,
} from './types';

export const ClusterVolumeMeasurements: React.FC<
  ClusterVolumeMeasurementsProps
> = ({ selectedDashboardCluster, volumeType }) => {
  // Variables.
  const { volume, weight } = getClusterVolumeAndWeightByType(
    selectedDashboardCluster,
    volumeType,
  );

  const volumeTypeLabel = DASHBOARD_VOLUME_TYPE_LABEL[volumeType].toUpperCase();

  const measurementItems: ClusterDetailItem[] = [
    {
      label: `${volumeTypeLabel} VOLUME`,
      value: formatMeasurement(volume, 'm³'),
    },
    {
      label: `${volumeTypeLabel} WEIGHT`,
      value: formatMeasurement(weight, 'tonnes'),
    },
  ];

  return (
    <div className="dashboard-modal__volume-selection__measurements">
      {measurementItems.map(({ label, value }) => (
        <div
          key={label}
          className="dashboard-modal__cluster-details-grid__item"
        >
          <span className="dashboard-modal__cluster-details-grid__item__label">
            {label}
          </span>

          <p>{value}</p>
        </div>
      ))}
    </div>
  );
};
